import {
  NavbarFirstLevelType,
  type NavbarFirstLevelItem,
} from '../components/Storage/Menu/helper'
import type { MenuLinkTreeFirstFragment } from '#build/graphql-operations'

export function useOldMenu(
  providedLinks: MenuLinkTreeFirstFragment[],
): ComputedRef<NavbarFirstLevelItem[]> {
  const { $texts } = useEasyTexts()

  function getSearchItem(): NavbarFirstLevelItem {
    return {
      link: {
        type: NavbarFirstLevelType.Search,
        content: {},
        label: $texts('search', 'Search'),
        url: { path: '' },
      },
      subtree: [],
    }
  }

  return computed(() => {
    const menuLinks: NavbarFirstLevelItem[] = providedLinks.map((link) => {
      const type = getFirstLevelType(link)
      return {
        link: {
          type,
          ...link.link,
        },
        subtree: [...link.subtree],
      }
    })

    menuLinks.push(getSearchItem())

    return menuLinks
  })
}

export function getSearchItem() {
  const { $texts } = useEasyTexts()
  return {
    link: {
      type: NavbarFirstLevelType.Search,
      content: {},
      label: $texts('search', 'Search'),
      url: {
        path: '',
      },
    },
    subtree: {},
  }
}

export function getFirstLevelType(item: MenuLinkTreeFirstFragment | undefined) {
  switch (item?.link?.content?.uuid) {
    case '80eef6a9-74da-4f36-88a1-413272cc0259':
    case '48709f8c-f210-4bb8-b2a0-4c0d01e4f801':
    case '25479c5d-78c8-4c9c-a3f6-cd81b066e281':
      return NavbarFirstLevelType.Social
  }

  return NavbarFirstLevelType.Default
}

export function useSubtreeIndex() {
  return useState<number>('useSubtreeIndex', () => -1)
}
